// Module
var code = "<div class=\"cssGridParent\"> <div class=\"actions\"></div> </div> ";
// Exports
export default code;